import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-update-locale',
  templateUrl: './update-locale.component.html',
  styleUrls: ['./update-locale.component.css']
})
export class UpdateLocaleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/locale/update-locale/update-locale.component.ts